(function () {
    var API_BASE = "https://fluxkompensator.motorize.de/priceoffer/api";
    var LOOKUP_URL = API_BASE + "/priceoffer_lookup";
    var CREATE_URL = API_BASE + "/priceoffer";

    function byId(id) { return document.getElementById(id); }

    function normalizeLangCode(raw) {
      var lang = String(raw || "").toLowerCase();
      if (!lang) return "de";
      var aliases = {
        "pt-pt": "pt",
        "pt-br": "pt",
        "zh-cn": "zh",
        "zh-hans": "zh",
        "zh-tw": "zh-tw",
        "zh-hk": "zh-tw"
      };
      if (aliases[lang]) return aliases[lang];
      return lang;
    }

    function detectLang() {
      try {
        if (window.Shopify && Shopify.locale) return normalizeLangCode(Shopify.locale);
      } catch (e) {}
      var path = (window.location.pathname || "").toLowerCase();
      var prefixes = [
        { p: "/de/", l: "de" },
        { p: "/en/", l: "en" },
        { p: "/fr/", l: "fr" },
        { p: "/it/", l: "it" },
        { p: "/es/", l: "es" },
        { p: "/pt/", l: "pt" },
        { p: "/pt-pt/", l: "pt" },
        { p: "/zh/", l: "zh" },
        { p: "/zh-cn/", l: "zh" },
        { p: "/zh-tw/", l: "zh-tw" },
        { p: "/ja/", l: "ja" },
        { p: "/nl/", l: "nl" },
        { p: "/pl/", l: "pl" },
        { p: "/ru/", l: "ru" },
        { p: "/cs/", l: "cs" },
        { p: "/da/", l: "da" },
        { p: "/fi/", l: "fi" },
        { p: "/no/", l: "no" },
        { p: "/sv/", l: "sv" },
        { p: "/hr/", l: "hr" },
        { p: "/hu/", l: "hu" },
        { p: "/ar/", l: "ar" },
        { p: "/he/", l: "he" }
      ];
      for (var i = 0; i < prefixes.length; i++) {
        if (path.indexOf(prefixes[i].p) === 0) return normalizeLangCode(prefixes[i].l);
      }
      return "de";
    }

    var I18N = {
      de: {
        btn: "Preisvorschlag senden",
        priceLabel: "Gesamtpreis (nur ganze Euro)",
        moreLabel: "Preisvorschlag fuer weitere Artikel senden und einen besseren Preis bekommen:",
        skuPh: "SKU / ID / Titel",
        add: "+ Hinzufuegen",
        email: "E-Mail",
        close: "Schliessen",
        send: "Absenden",
        errEmail: "Bitte E-Mail eingeben.",
        errItems: "Kein Artikel vorhanden.",
        errPrice: "Bitte Gesamtpreis eingeben.",
        errFind: "Kein Artikel gefunden.",
        errLookup: "Fehler bei der Artikelsuche.",
        ok: "Danke! Dein Preisvorschlag wurde gesendet.",
        errSend: "Fehler beim Senden."
      },
      en: {
        btn: "Send price offer",
        priceLabel: "Total price (whole euros only)",
        moreLabel: "Add more items to get a better price:",
        skuPh: "SKU / ID / Title",
        add: "+ Add",
        email: "Email",
        close: "Close",
        send: "Send",
        errEmail: "Please enter email.",
        errItems: "No item.",
        errPrice: "Please enter total price.",
        errFind: "No item found.",
        errLookup: "Error searching item.",
        ok: "Thanks! Your offer was sent.",
        errSend: "Error sending."
      },
      fr: {
        btn: "Envoyer une offre",
        priceLabel: "Prix total (euros entiers seulement)",
        moreLabel: "Ajoutez d'autres articles pour obtenir un meilleur prix :",
        skuPh: "SKU / ID / Titre",
        add: "+ Ajouter",
        email: "E-mail",
        close: "Fermer",
        send: "Envoyer",
        errEmail: "Veuillez saisir un e-mail.",
        errItems: "Aucun article.",
        errPrice: "Veuillez saisir le prix total.",
        errFind: "Aucun article trouve.",
        errLookup: "Erreur lors de la recherche.",
        ok: "Merci ! Votre offre a ete envoyee.",
        errSend: "Erreur lors de l'envoi."
      },
      it: {
        btn: "Invia offerta",
        priceLabel: "Prezzo totale (solo euro interi)",
        moreLabel: "Aggiungi altri articoli per ottenere un prezzo migliore:",
        skuPh: "SKU / ID / Titolo",
        add: "+ Aggiungi",
        email: "Email",
        close: "Chiudi",
        send: "Invia",
        errEmail: "Inserisci l'email.",
        errItems: "Nessun articolo.",
        errPrice: "Inserisci il prezzo totale.",
        errFind: "Articolo non trovato.",
        errLookup: "Errore nella ricerca.",
        ok: "Grazie! La tua offerta e stata inviata.",
        errSend: "Errore durante l'invio."
      },
      es: {
        btn: "Enviar oferta",
        priceLabel: "Precio total (solo euros enteros)",
        moreLabel: "Anade mas articulos para obtener un mejor precio:",
        skuPh: "SKU / ID / Titulo",
        add: "+ Anadir",
        email: "Correo electronico",
        close: "Cerrar",
        send: "Enviar",
        errEmail: "Introduce el correo electronico.",
        errItems: "No hay articulos.",
        errPrice: "Introduce el precio total.",
        errFind: "Articulo no encontrado.",
        errLookup: "Error en la busqueda.",
        ok: "Gracias. Tu oferta ha sido enviada.",
        errSend: "Error al enviar."
      },
      pt: {
        btn: "Enviar oferta",
        priceLabel: "Preco total (apenas euros inteiros)",
        moreLabel: "Adicione mais artigos para obter um melhor preco:",
        skuPh: "SKU / ID / Titulo",
        add: "+ Adicionar",
        email: "Email",
        close: "Fechar",
        send: "Enviar",
        errEmail: "Introduza o email.",
        errItems: "Nenhum artigo.",
        errPrice: "Introduza o preco total.",
        errFind: "Artigo nao encontrado.",
        errLookup: "Erro na pesquisa.",
        ok: "Obrigado! A sua oferta foi enviada.",
        errSend: "Erro ao enviar."
      },
      zh: {
        btn: "发送报价",
        priceLabel: "总价（仅整数欧元）",
        moreLabel: "添加更多商品以获得更优惠的价格：",
        skuPh: "SKU / ID / 标题",
        add: "+ 添加",
        email: "邮箱",
        close: "关闭",
        send: "发送",
        errEmail: "请输入邮箱。",
        errItems: "没有商品。",
        errPrice: "请输入总价。",
        errFind: "未找到商品。",
        errLookup: "搜索出错。",
        ok: "谢谢！报价已发送。",
        errSend: "发送失败。"
      },
      ja: {
        btn: "価格提案を送信",
        priceLabel: "合計金額（整数ユーロのみ）",
        moreLabel: "さらに商品を追加して、より良い価格を取得：",
        skuPh: "SKU / ID / タイトル",
        add: "+ 追加",
        email: "メール",
        close: "閉じる",
        send: "送信",
        errEmail: "メールアドレスを入力してください。",
        errItems: "商品がありません。",
        errPrice: "合計金額を入力してください。",
        errFind: "商品が見つかりません。",
        errLookup: "検索エラー。",
        ok: "ありがとうございます。送信しました。",
        errSend: "送信エラー。"
      },
      nl: {
        btn: "Prijsvoorstel sturen",
        priceLabel: "Totaalprijs (alleen hele euro's)",
        moreLabel: "Voeg meer artikelen toe voor een betere prijs:",
        skuPh: "SKU / ID / Titel",
        add: "+ Toevoegen",
        email: "E-mail",
        close: "Sluiten",
        send: "Verzenden",
        errEmail: "Voer een e-mailadres in.",
        errItems: "Geen artikel.",
        errPrice: "Voer de totaalprijs in.",
        errFind: "Geen artikel gevonden.",
        errLookup: "Zoekfout.",
        ok: "Bedankt! Je voorstel is verzonden.",
        errSend: "Fout bij verzenden."
      },
      pl: {
        btn: "Wyslij oferte",
        priceLabel: "Cena laczna (tylko pelne euro)",
        moreLabel: "Dodaj wiecej produktow, aby uzyskac lepsza cene:",
        skuPh: "SKU / ID / Tytul",
        add: "+ Dodaj",
        email: "E-mail",
        close: "Zamknij",
        send: "Wyslij",
        errEmail: "Podaj adres e-mail.",
        errItems: "Brak produktu.",
        errPrice: "Podaj cene laczna.",
        errFind: "Nie znaleziono produktu.",
        errLookup: "Blad wyszukiwania.",
        ok: "Dziekujemy! Oferta zostala wyslana.",
        errSend: "Blad wysylania."
      },
      ru: {
        btn: "Отправить предложение",
        priceLabel: "Итоговая цена (только целые евро)",
        moreLabel: "Добавьте еще товары, чтобы получить лучшую цену:",
        skuPh: "SKU / ID / Название",
        add: "+ Добавить",
        email: "E-mail",
        close: "Закрыть",
        send: "Отправить",
        errEmail: "Введите e-mail.",
        errItems: "Нет товара.",
        errPrice: "Введите итоговую цену.",
        errFind: "Товар не найден.",
        errLookup: "Ошибка поиска.",
        ok: "Спасибо! Предложение отправлено.",
        errSend: "Ошибка отправки."
      },
      cs: {
        btn: "Odeslat nabidku",
        priceLabel: "Celkova cena (pouze cela eura)",
        moreLabel: "Pridejte dalsi polozky pro lepsi cenu:",
        skuPh: "SKU / ID / Nazev",
        add: "+ Pridat",
        email: "E-mail",
        close: "Zavrit",
        send: "Odeslat",
        errEmail: "Zadejte e-mail.",
        errItems: "Zadna polozka.",
        errPrice: "Zadejte celkovou cenu.",
        errFind: "Polozka nenalezena.",
        errLookup: "Chyba vyhledavani.",
        ok: "Dekujeme! Nabidka byla odeslana.",
        errSend: "Chyba odeslani."
      },
      da: {
        btn: "Send pristilbud",
        priceLabel: "Samlet pris (kun hele euro)",
        moreLabel: "Tilfoj flere varer for at fa en bedre pris:",
        skuPh: "SKU / ID / Titel",
        add: "+ Tilfoj",
        email: "E-mail",
        close: "Luk",
        send: "Send",
        errEmail: "Indtast e-mail.",
        errItems: "Ingen vare.",
        errPrice: "Indtast samlet pris.",
        errFind: "Ingen vare fundet.",
        errLookup: "Fejl ved sogning.",
        ok: "Tak! Dit tilbud er sendt.",
        errSend: "Fejl ved afsendelse."
      },
      fi: {
        btn: "Laheta tarjous",
        priceLabel: "Kokonaishinta (vain kokonaiset eurot)",
        moreLabel: "Lisaa tuotteita saadaksesi paremman hinnan:",
        skuPh: "SKU / ID / Otsikko",
        add: "+ Lisaa",
        email: "Sahkoposti",
        close: "Sulje",
        send: "Laheta",
        errEmail: "Anna sahkopostiosoite.",
        errItems: "Ei tuotetta.",
        errPrice: "Anna kokonaishinta.",
        errFind: "Tuotetta ei loytynyt.",
        errLookup: "Hakvirhe.",
        ok: "Kiitos! Tarjous on lahetetty.",
        errSend: "Lahetysvirhe."
      },
      no: {
        btn: "Send pristilbud",
        priceLabel: "Totalpris (kun hele euro)",
        moreLabel: "Legg til flere varer for a fa en bedre pris:",
        skuPh: "SKU / ID / Tittel",
        add: "+ Legg til",
        email: "E-post",
        close: "Lukk",
        send: "Send",
        errEmail: "Skriv inn e-post.",
        errItems: "Ingen vare.",
        errPrice: "Skriv inn totalpris.",
        errFind: "Ingen vare funnet.",
        errLookup: "Sokefeil.",
        ok: "Takk! Tilbudet er sendt.",
        errSend: "Feil ved sending."
      },
      sv: {
        btn: "Skicka prisforslag",
        priceLabel: "Totalpris (endast hela euro)",
        moreLabel: "Lagg till fler artiklar for ett battre pris:",
        skuPh: "SKU / ID / Titel",
        add: "+ Lagg till",
        email: "E-post",
        close: "Stang",
        send: "Skicka",
        errEmail: "Ange e-post.",
        errItems: "Ingen artikel.",
        errPrice: "Ange totalpris.",
        errFind: "Ingen artikel hittad.",
        errLookup: "Sokfel.",
        ok: "Tack! Ditt forslag skickades.",
        errSend: "Fel vid skickning."
      }
    };
    I18N["pt-pt"] = I18N.pt;
    I18N["zh-cn"] = I18N.zh;
    I18N["zh-tw"] = Object.assign({}, I18N.zh, { btn: "發送報價" });
    I18N.hr = Object.assign({}, I18N.en, { btn: "Posalji prijedlog cijene" });
    I18N.hu = Object.assign({}, I18N.en, { btn: "Arajanlat kuldese" });
    I18N.ar = Object.assign({}, I18N.en, { btn: "إرسال عرض سعر" });
    I18N.he = Object.assign({}, I18N.en, { btn: "שליחת הצעת מחיר" });
    /* mz-priceoffer-locale-extensions-v1 */

    function applyI18n() {
      var lang = detectLang();
      var t = I18N[lang] || I18N.en;

      if (byId("mo-btn")) byId("mo-btn").textContent = t.btn;
      if (byId("mo-label-price")) byId("mo-label-price").textContent = t.priceLabel;
      if (byId("mo-label-more")) byId("mo-label-more").textContent = t.moreLabel;
      if (byId("mo-sku")) byId("mo-sku").setAttribute("placeholder", t.skuPh);
      if (byId("mo-add")) byId("mo-add").textContent = t.add;
      if (byId("mo-label-email")) byId("mo-label-email").textContent = t.email;
      if (byId("mo-cancel")) byId("mo-cancel").textContent = t.close;
      if (byId("mo-send")) byId("mo-send").textContent = t.send;
      applyCurrencyLabel(t);

      return t;
    }

    function normalizeInt(v) {
      var s = String(v || "").replace(/[^\d]/g, "");
      if (!s) return "";
      return String(parseInt(s, 10));
    }

    function normalizeImage(url) {
      if (!url) return "";
      if (url.indexOf("//") === 0) return "https:" + url;
      return url;
    }

    function normalizePrice(p) {
      if (p == null) return 0;
      var n = Number(p);
      if (!isFinite(n)) return 0;
      if (n > 1000 && Number.isInteger(n)) return Math.round(n) / 100;
      return n;
    }

    function getActiveCurrency() {
      try {
        if (window.Shopify && Shopify.currency && Shopify.currency.active) {
          return String(Shopify.currency.active).toUpperCase();
        }
      } catch (e) {}
      try {
        if (window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.currency) {
          return String(ShopifyAnalytics.meta.currency).toUpperCase();
        }
      } catch (e) {}
      var ogCurrency = document.querySelector('meta[property="og:price:currency"]');
      if (ogCurrency && ogCurrency.content) return String(ogCurrency.content).toUpperCase();
      try {
        var url = new URL(window.location.href);
        var qp = url.searchParams.get("currency");
        if (qp) return String(qp).toUpperCase();
      } catch (e) {}
      return "EUR";
    }

    function parseDisplayedMoney(text) {
      var s = String(text || "").replace(/\s+/g, " ").trim();
      if (!s) return 0;
      s = s.replace(/[^0-9,.-]/g, "");
      if (!s) return 0;
      var lastComma = s.lastIndexOf(",");
      var lastDot = s.lastIndexOf(".");
      var decimalSep = "";
      if (lastComma !== -1 && lastDot !== -1) {
        decimalSep = lastComma > lastDot ? "," : ".";
      } else if (lastComma !== -1) {
        decimalSep = (s.length - lastComma - 1) <= 2 ? "," : "";
      } else if (lastDot !== -1) {
        decimalSep = (s.length - lastDot - 1) <= 2 ? "." : "";
      }
      if (decimalSep) {
        var thousandSep = decimalSep === "," ? "." : ",";
        s = s.split(thousandSep).join("");
        if (decimalSep !== ".") s = s.replace(decimalSep, ".");
      } else {
        s = s.replace(/[.,]/g, "");
      }
      var n = Number(s);
      return isFinite(n) ? n : 0;
    }

    function getDisplayedPrice() {
      var selectors = [
        '[data-variant-price]',
        '.price-preview',
        '.product-single__price',
        '[itemprop="price"]'
      ];
      for (var i = 0; i < selectors.length; i++) {
        var nodes = document.querySelectorAll(selectors[i]);
        for (var j = 0; j < nodes.length; j++) {
          var val = parseDisplayedMoney(nodes[j].textContent || "");
          if (val > 0) return val;
        }
      }
      return 0;
    }

    function applyCurrencyLabel(t) {
      var label = byId("mo-label-price");
      if (!label) return;
      var currency = getActiveCurrency();
      var lang = detectLang();
      var templates = {
        de: "Gesamtpreis (nur ganze {currency})",
        en: "Total price (whole {currency} only)",
        fr: "Prix total ({currency} entiers seulement)",
        it: "Prezzo totale (solo {currency} interi)",
        es: "Precio total (solo {currency} enteros)",
        pt: "Preco total (apenas {currency} inteiros)",
        nl: "Totaalprijs (alleen hele {currency})",
        pl: "Cena laczna (tylko pelne {currency})",
        ru: "Итоговая цена (только целые {currency})",
        cs: "Celkova cena (pouze cela {currency})",
        da: "Samlet pris (kun hele {currency})",
        fi: "Kokonaishinta (vain kokonaiset {currency})",
        no: "Totalpris (kun hele {currency})",
        sv: "Totalpris (endast hela {currency})",
        zh: "总价（仅整数 {currency}）",
        ja: "合計金額（{currency} の整数のみ）"
      };
      var template = templates[lang] || templates.en;
      label.textContent = template.replace("{currency}", currency);
    }
    /* mz-priceoffer-label-translations-v1 */

    function getProductData() {
      var prod = null;
      try { if (window.meta && window.meta.product) prod = window.meta.product; } catch (e) {}
      try { if (!prod && window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.product) prod = ShopifyAnalytics.meta.product; } catch (e) {}
      if (!prod) {
        try {
          var productJsonEl = document.querySelector('script[id^="ProductJson-"]');
          if (productJsonEl && productJsonEl.textContent) prod = JSON.parse(productJsonEl.textContent).product_info || null;
        } catch (e) {}
      }
      if (!prod) return null;

      var variants = prod.variants || [];
      var selectedId = null;
      var sel = document.querySelector('form[action*="/cart/add"] [name="id"]');
      if (sel && sel.value) selectedId = String(sel.value);

      var variant = null;
      for (var i = 0; i < variants.length; i++) {
        if (selectedId && String(variants[i].id) === String(selectedId)) {
          variant = variants[i];
          break;
        }
      }
      if (!variant && variants.length) variant = variants[0];

      var sku = variant && variant.sku ? variant.sku : "";
      var title = prod.title || "";
      if (!title) {
        var heading = document.querySelector('.product-header h1, h1.section-title-36, .product-details h1');
        if (heading) title = (heading.textContent || "").trim();
      }
      if (!title) title = document.title || "";
      if (variant && variant.title && variant.title.toLowerCase() !== "default title") {
        title = title + " - " + variant.title;
      }

      var image = "";
      if (variant && variant.featured_image && variant.featured_image.src) image = variant.featured_image.src;
      if (!image && variant && variant.image && variant.image.src) image = variant.image.src;
      if (!image && prod.featured_image && prod.featured_image.url) image = prod.featured_image.url;
      if (!image && prod.featured_image) image = prod.featured_image;
      if (!image && prod.images && prod.images.length) image = (prod.images[0].src || prod.images[0]);
      if (!image) {
        var domImg = document.querySelector('.mz-product-main-stage img, .featured-image img, [id^="main-product-image-"] img');
        if (domImg) image = domImg.getAttribute('data-source') || domImg.getAttribute('data-src') || domImg.getAttribute('src') || "";
      }
      if (!image) {
        var ogImage = document.querySelector('meta[property="og:image"], meta[name="twitter:image"]');
        if (ogImage) image = ogImage.getAttribute('content') || "";
      }

      image = normalizeImage(image);

      var activeCurrency = getActiveCurrency();
      var priceValue = normalizePrice((variant && variant.price) || prod.price || prod.price_min || 0);
      var displayedPrice = getDisplayedPrice();
      if (displayedPrice > 0 && (!priceValue || activeCurrency !== "EUR" || Math.abs(priceValue - displayedPrice) > Math.max(1, displayedPrice * 0.2))) {
        priceValue = displayedPrice;
      }

      return {
        product_id: variant && variant.product_id ? variant.product_id : (prod.id || ""),
        variant_id: variant && variant.id ? variant.id : "",
        sku: sku,
        title: title,
        image_url: image,
        price: priceValue,
        currency: activeCurrency
      };
    }
    /* mz-priceoffer-asset-fix-v1 */
    /* mz-priceoffer-currency-fix-v1 */

    function isUsedPartSku(sku) {
      var normalized = String(sku || "").trim().toUpperCase();
      return /^MGT1-\d+(?:-\d+)*$/.test(normalized);
    }

    var supportedOfferCurrencies = {"EUR":true,"USD":true,"CAD":true,"GBP":true,"CHF":true,"SEK":true,"DKK":true,"NOK":true,"AUD":true};

    function hasOfferableProduct() {
      var prod = getProductData();
      if (!prod) return false;
      var currency = String(prod.currency || getActiveCurrency() || "").toUpperCase();
      if (!supportedOfferCurrencies[currency]) return false;
      if (!isUsedPartSku(prod.sku)) return false;
      return !!(prod.variant_id || prod.product_id || prod.title);
    }
    /* mz-priceoffer-multi-currency-v1 */

    function showButton() {
      var wrap = byId("mo-wrap");
      var panel = byId("mo-panel");
      if (!wrap) return;
      var visible = hasOfferableProduct();
      wrap.style.display = visible ? "block" : "none";
      if (!visible && panel) panel.style.display = "none";
    }
    /* mz-priceoffer-visibility-rules-v2 */

    var items = [];
    var t = null;
    var offerSubmitInFlight = false;
    var offerSubmitted = false;

    function renderItems() {
      var wrap = byId("mo-items");
      if (!wrap) return;
      var html = "";
      for (var i = 0; i < items.length; i++) {
        var it = items[i];
        html += '<div style="display:flex;gap:10px;align-items:center;background:#fff;border:1px solid #ddd;border-radius:10px;padding:8px;margin-bottom:8px;">';
        html += '<div style="width:54px;height:54px;border:1px solid #ddd;border-radius:8px;background:#fff;overflow:hidden;flex:0 0 54px;display:flex;align-items:center;justify-content:center;">';
        if (it.image_url) {
          html += '<img src="' + it.image_url + '" alt="" style="display:block;width:100%;height:100%;object-fit:contain;">';
        }
        html += '</div>';
        html += '<div style="flex:1;font-size:13px;font-weight:700;color:#d74d01;">' + (it.title || it.sku || "") + '</div>';
        html += '</div>';
      }
      wrap.innerHTML = html;
    }

    function addBaseItem() {
      items = [];
      var base = getProductData();
      if (!base) return;
      if (!hasOfferableProduct()) return;
      items.push(base);
      renderItems();
    }

    function fetchJson(url) {
      return fetch(url, { credentials: "omit" }).then(function (r) { return r.json(); });
    }

    function addExtraItem() {
      var inp = byId("mo-sku");
      if (!inp) return;
      var q = (inp.value || "").trim();
      if (!q) return;
      inp.value = "";
      fetchJson(LOOKUP_URL + "?q=" + encodeURIComponent(q))
        .then(function (data) {
          var list = (data && data.items) ? data.items : [];
          if (!list.length) { alert(t.errFind); return; }
          items.push(list[0]);
          renderItems();
        })
        .catch(function () { alert(t.errLookup); });
    }

    function sendOffer() {
      if (offerSubmitted) {
        alert((t && t.ok) ? t.ok : "Danke! Dein Preisvorschlag wurde gesendet.");
        return;
      }
      if (offerSubmitInFlight) return;

      var email = (byId("mo-email") || {}).value || "";
      var offerTotal = normalizeInt((byId("mo-price") || {}).value || "");

      if (!email.trim()) { alert(t.errEmail); return; }
      if (!items.length) { alert(t.errItems); return; }
      if (!offerTotal) { alert(t.errPrice); return; }

      offerSubmitInFlight = true;
      var sendBtn = byId("mo-send");
      var sendLabel = (t && t.send) ? t.send : "Absenden";
      var sendingLabel = "Wird gesendet...";
      var sentLabel = "Gesendet";
      if (sendBtn) {
        sendBtn.disabled = true;
        sendBtn.textContent = sendingLabel;
      }

      var activeCurrency = getActiveCurrency();
      var payload = {
        items: items.map(function (it) {
          var itemPrice = normalizePrice(it.price || 0);
          return {
            product_id: it.product_id || "",
            variant_id: it.variant_id || "",
            sku: it.sku || "",
            title: it.title || "",
            image_url: it.image_url || "",
            qty: 1,
            price: itemPrice,
            offer_price: itemPrice
          };
        }),
        currency: activeCurrency,
        language: detectLang(),
        customer_email: email.trim(),
        customer_message: "",
        offer_total: parseInt(offerTotal, 10),
        meta: {
          page_url: window.location.href,
          currency: activeCurrency
        }
      };

      fetch(CREATE_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload)
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (data && data.ok === false) {
            throw new Error("request_failed");
          }
          offerSubmitted = true;
          offerSubmitInFlight = false;
          if (sendBtn) {
            sendBtn.disabled = true;
            sendBtn.textContent = sentLabel;
          }
          alert(t.ok);
          if (byId("mo-panel")) byId("mo-panel").style.display = "none";
        })
        .catch(function () {
          offerSubmitInFlight = false;
          if (sendBtn) {
            sendBtn.disabled = false;
            sendBtn.textContent = sendLabel;
          }
          alert(t.errSend);
        });
    }

    function normalizeProductCtaLayout() {
      var mobile = window.matchMedia && window.matchMedia("(max-width: 749px)").matches;
      var offerWrap = byId("mo-wrap");
      var offerBtn = byId("mo-btn");
      var panel = byId("mo-panel");
      var askWrap = document.querySelector(".motorize-mailbtn-wrap");
      var askBtn = document.querySelector(".motorize-mailbtn");

      if (offerWrap) {
        offerWrap.style.width = mobile ? "100%" : "50%";
        offerWrap.style.marginLeft = mobile ? "0" : "auto";
        offerWrap.style.textAlign = mobile ? "center" : "right";
        offerWrap.style.boxSizing = "border-box";
      }
      if (offerBtn) {
        offerBtn.style.width = "100%";
        offerBtn.style.maxWidth = "none";
        offerBtn.style.display = "block";
        offerBtn.style.boxSizing = "border-box";
      }
      if (panel) {
        panel.style.width = mobile ? "100%" : "50%";
        panel.style.marginLeft = mobile ? "0" : "auto";
        panel.style.boxSizing = "border-box";
      }
      if (askWrap) {
        askWrap.style.width = mobile ? "100%" : "50%";
        askWrap.style.marginLeft = mobile ? "0" : "auto";
        askWrap.style.textAlign = mobile ? "center" : "right";
        askWrap.style.boxSizing = "border-box";
      }
      if (askBtn) {
        askBtn.style.setProperty("width", "100%", "important");
        askBtn.style.setProperty("max-width", "none", "important");
        askBtn.style.setProperty("display", "flex", "important");
        askBtn.style.setProperty("box-sizing", "border-box", "important");
        askBtn.style.setProperty("align-items", "center", "important");
        askBtn.style.setProperty("justify-content", "center", "important");
      }
      /* mz-question-button-width-force-v1 */
    }
    /* mz-priceoffer-cta-width-normalize-v1 */

    function bind() {
      t = applyI18n();
      showButton();
      normalizeProductCtaLayout();

      var btn = byId("mo-btn");
      var panel = byId("mo-panel");

      if (btn) btn.addEventListener("click", function (event) {
        event.preventDefault();
        event.stopImmediatePropagation();
        addBaseItem();
        if (!items.length) return;
        if (panel) panel.style.display = "block";
      }, true);

      var add = byId("mo-add");
      if (add) add.addEventListener("click", addExtraItem);

      var cancel = byId("mo-cancel");
      if (cancel) cancel.addEventListener("click", function (event) {
        event.preventDefault();
        event.stopImmediatePropagation();
        if (panel) panel.style.display = "none";
      }, true);

      var send = byId("mo-send");
      if (send) send.addEventListener("click", sendOffer);

      var price = byId("mo-price");
      if (price) {
        price.addEventListener("input", function () {
          price.value = normalizeInt(price.value);
        });
      }

      var sel = document.querySelector('form[action*="/cart/add"] [name="id"]');
      if (sel) sel.addEventListener("change", showButton);

      window.addEventListener("resize", normalizeProductCtaLayout);
      setTimeout(normalizeProductCtaLayout, 50);
      setTimeout(normalizeProductCtaLayout, 400);
    }

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", bind);
    } else {
      bind();
    }
  })();


;(function(){
  // mz-adwords-price-test-countdown-asset-v2
  // mz-adwords-price-test-i18n-layout-v3
  function productHandle(){
    var m = location.pathname.match(/\/products\/([^\/?#]+)/);
    return m ? decodeURIComponent(m[1]) : "";
  }
  function two(n){ return n < 10 ? "0" + n : "" + n; }
  function detectLang(){
    try {
      if (window.Shopify && Shopify.locale) return String(Shopify.locale).toLowerCase();
    } catch (e) {}
    var path = (window.location.pathname || "").toLowerCase();
    var prefixes = [
      { p: "/de/", l: "de" },
      { p: "/en/", l: "en" },
      { p: "/fr/", l: "fr" },
      { p: "/it/", l: "it" },
      { p: "/es/", l: "es" },
      { p: "/pt/", l: "pt" },
      { p: "/zh/", l: "zh" },
      { p: "/ja/", l: "ja" },
      { p: "/nl/", l: "nl" },
      { p: "/pl/", l: "pl" },
      { p: "/ru/", l: "ru" },
      { p: "/cs/", l: "cs" },
      { p: "/da/", l: "da" },
      { p: "/fi/", l: "fi" },
      { p: "/no/", l: "no" },
      { p: "/sv/", l: "sv" }
    ];
    for (var i = 0; i < prefixes.length; i++) {
      if (path.indexOf(prefixes[i].p) === 0) return prefixes[i].l;
    }
    return "de";
  }
  var PROMO_I18N = {
    de: { label: "AKTIONSPREIS", endsIn: "endet in", dayOne: "Tag", dayMany: "Tage", hourUnit: "Std." },
    en: { label: "SALE PRICE", endsIn: "ends in", dayOne: "day", dayMany: "days", hourUnit: "hrs" },
    fr: { label: "PRIX PROMO", endsIn: "se termine dans", dayOne: "jour", dayMany: "jours", hourUnit: "h" },
    it: { label: "PREZZO PROMO", endsIn: "termina tra", dayOne: "giorno", dayMany: "giorni", hourUnit: "ore" },
    es: { label: "PRECIO PROMO", endsIn: "termina en", dayOne: "dia", dayMany: "dias", hourUnit: "h" },
    pt: { label: "PRECO PROMO", endsIn: "termina em", dayOne: "dia", dayMany: "dias", hourUnit: "h" },
    zh: { label: "促销价", endsIn: "结束于", dayOne: "天", dayMany: "天", hourUnit: "小时" },
    ja: { label: "セール価格", endsIn: "終了まで", dayOne: "日", dayMany: "日", hourUnit: "時間" },
    nl: { label: "ACTIEPRIJS", endsIn: "eindigt over", dayOne: "dag", dayMany: "dagen", hourUnit: "uur" },
    pl: { label: "CENA PROMOCYJNA", endsIn: "konczy sie za", dayOne: "dzien", dayMany: "dni", hourUnit: "godz." },
    ru: { label: "АКЦИОННАЯ ЦЕНА", endsIn: "заканчивается через", dayOne: "дн.", dayMany: "дн.", hourUnit: "ч." },
    cs: { label: "AKCNI CENA", endsIn: "konci za", dayOne: "den", dayMany: "dny", hourUnit: "hod." },
    da: { label: "TILBUDSPRIS", endsIn: "slutter om", dayOne: "dag", dayMany: "dage", hourUnit: "t" },
    fi: { label: "TARJOUSHINTA", endsIn: "paattyy", dayOne: "paiva", dayMany: "paivaa", hourUnit: "h" },
    no: { label: "KAMPANJEPRIS", endsIn: "utloper om", dayOne: "dag", dayMany: "dager", hourUnit: "t" },
    sv: { label: "KAMPANJPRIS", endsIn: "slutar om", dayOne: "dag", dayMany: "dagar", hourUnit: "tim" }
  };
  function promoCopy(){
    var lang = detectLang();
    return PROMO_I18N[lang] || PROMO_I18N.en;
  }
  function parseEnd(raw){
    raw = String(raw || "").trim();
    var m = raw.match(/^(\d{4})(\d{2})(\d{2})T(\d{2})(\d{2})(\d{2})Z$/);
    if (m) return Date.UTC(+m[1], +m[2] - 1, +m[3], +m[4], +m[5], +m[6]);
    return Date.parse(raw);
  }
  function tagValue(tags, prefix){
    for (var i = 0; i < tags.length; i++) {
      var tag = String(tags[i] || "");
      if (tag.indexOf(prefix) === 0) return tag.slice(prefix.length);
    }
    return "";
  }
  function hasTag(tags, value){
    value = String(value || "").toLowerCase();
    for (var i = 0; i < tags.length; i++) {
      if (String(tags[i] || "").toLowerCase() === value) return true;
    }
    return false;
  }
  function renderCountdown(endRaw){
    var end = parseEnd(endRaw);
    if (!end) return;
    var host = document.querySelector(".product-details-price") || document.querySelector("[data-variant-price]");
    if (!host || document.getElementById("mz-adwords-price-test-countdown")) return;
    var box = document.createElement("div");
    box.id = "mz-adwords-price-test-countdown";
    box.setAttribute("data-end", endRaw);
    var copy = promoCopy();
    box.style.cssText = "display:block;margin:8px 0 0 0;padding:0;color:#2a2a2a;font-size:15px;line-height:1.25;text-align:right";
    box.innerHTML = '<strong style="color:#d74d01;font-weight:800;font-size:1.08em;letter-spacing:.04em;text-transform:uppercase">' + copy.label + '</strong><br><span style="font-weight:500">' + copy.endsIn + ' <b data-mz-days style="font-weight:800">7 ' + copy.dayMany + '</b> <b data-mz-time style="font-weight:800">00:00 ' + copy.hourUnit + '</b></span>';
    host.appendChild(box);
    function update(){
      var daysEl = box.querySelector("[data-mz-days]");
      var timeEl = box.querySelector("[data-mz-time]");
      if (!daysEl || !timeEl) return;
      var diff = end - Date.now();
      if (diff <= 0) {
        daysEl.textContent = "0 " + copy.dayMany;
        timeEl.textContent = "00:00 " + copy.hourUnit;
        return;
      }
      var totalMinutes = Math.floor(diff / 60000);
      var days = Math.floor(totalMinutes / 1440);
      var hours = Math.floor((totalMinutes % 1440) / 60);
      var minutes = totalMinutes % 60;
      var dayWord = days === 1 ? copy.dayOne : copy.dayMany;
      daysEl.textContent = days + " " + dayWord;
      timeEl.textContent = two(hours) + ":" + two(minutes) + " " + copy.hourUnit;
    }
    update();
    window.clearInterval(window.__mzAdwordsPriceTestCountdown);
    window.__mzAdwordsPriceTestCountdown = window.setInterval(update, 60000);
  }
  function addLineItemProperties(testId, endRaw){
    var form = document.querySelector('form[action*="/cart/add"]');
    if (!form || form.querySelector('input[name="properties[priceoffer]"]')) return;
    var input = document.createElement("input");
    input.type = "hidden";
    input.name = "properties[priceoffer]";
    input.value = testId || "priceoffer";
    form.appendChild(input);
    var endInput = document.createElement("input");
    endInput.type = "hidden";
    endInput.name = "properties[priceoffer_ends_at]";
    endInput.value = endRaw || "";
    form.appendChild(endInput);
  }
  function init(){
    var handle = productHandle();
    if (!handle) return;
    fetch("/products/" + encodeURIComponent(handle) + ".js", {credentials:"same-origin"})
      .then(function(r){ return r.ok ? r.json() : null; })
      .then(function(product){
        if (!product || !product.tags) return;
        var tags = product.tags || [];
        if (!hasTag(tags, "priceoffer")) return;
        var endRaw = tagValue(tags, "priceoffer_end_");
        if (!endRaw) return;
        var testId = "";
        for (var i = 0; i < tags.length; i++) {
          var tag = String(tags[i] || "");
          if (tag.indexOf("priceoffer_adwords_") === 0) testId = tag;
        }
        renderCountdown(endRaw);
        addLineItemProperties(testId, endRaw);
      })
      .catch(function(){});
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();


;(function(){
  // mz-adwords-price-test-layout-v2
  function productHandle(){
    var m = location.pathname.match(/\/products\/([^\/?#]+)/);
    return m ? decodeURIComponent(m[1]) : "";
  }
  function hasTag(tags, value){
    value = String(value || "").toLowerCase();
    for (var i = 0; i < tags.length; i++) {
      if (String(tags[i] || "").toLowerCase() === value) return true;
    }
    return false;
  }
  function ensureStyles(){
    if (document.getElementById("mz-adwords-price-test-layout-style")) return;
    var style = document.createElement("style");
    style.id = "mz-adwords-price-test-layout-style";
    style.textContent = [
      ".product-details-price[data-mz-adwords-price-test-layout] h2.offers{display:block!important;line-height:1.05!important}",
      ".product-details-price[data-mz-adwords-price-test-layout] h2.offers.mgt-price-banner-host-clean,.product-details-price[data-mz-adwords-price-test-layout] .offers.mgt-price-banner-host-clean{display:flex!important;align-items:center!important;justify-content:flex-start!important;gap:10px!important;flex-wrap:nowrap!important}",
      ".product-details-price[data-mz-adwords-price-test-layout] .mgt-price-banner-host-clean .price-preview{width:auto!important;flex:0 0 auto!important}",
      ".product-details-price[data-mz-adwords-price-test-layout] .mgt-price-country-banner-clean{display:inline-flex!important;align-items:center!important;justify-content:center!important;min-height:36px!important;padding:4px 10px!important;margin:0!important;width:auto!important;max-width:420px!important;line-height:1.1!important}",
      ".product-details-price[data-mz-adwords-price-test-layout] h2.offers.mgt-price-banner-host,.product-details-price[data-mz-adwords-price-test-layout] .offers.mgt-price-banner-host{display:flex!important;align-items:center!important;justify-content:flex-start!important;gap:10px!important;flex-wrap:nowrap!important}",
      ".product-details-price[data-mz-adwords-price-test-layout] .mgt-price-banner-host .price-preview{width:auto!important;flex:0 0 auto!important}",
      ".product-details-price[data-mz-adwords-price-test-layout] .mgt-price-country-banner{display:inline-flex!important;align-items:center!important;justify-content:center!important;min-height:36px!important;padding:4px 10px!important;margin:0!important;width:auto!important;max-width:420px!important;line-height:1.1!important}",
      "@media(max-width:749px){.product-details-price[data-mz-adwords-price-test-layout] h2.offers.mgt-price-banner-host-clean,.product-details-price[data-mz-adwords-price-test-layout] .offers.mgt-price-banner-host-clean,.product-details-price[data-mz-adwords-price-test-layout] h2.offers.mgt-price-banner-host,.product-details-price[data-mz-adwords-price-test-layout] .offers.mgt-price-banner-host{flex-wrap:wrap!important;align-items:flex-start!important}.product-details-price[data-mz-adwords-price-test-layout] .mgt-price-country-banner-clean,.product-details-price[data-mz-adwords-price-test-layout] .mgt-price-country-banner{width:100%!important;max-width:100%!important;min-height:34px!important}}",
      ".product-details-price[data-mz-adwords-price-test-layout] h2.offers.mgt-price-banner-host-clean,.product-details-price[data-mz-adwords-price-test-layout] .offers.mgt-price-banner-host-clean{display:flex!important;align-items:center!important;justify-content:flex-start!important;gap:10px!important;flex-wrap:nowrap!important}",
      ".product-details-price[data-mz-adwords-price-test-layout] .mgt-price-country-banner-clean{display:inline-flex!important;align-items:center!important;justify-content:center!important;min-height:36px!important;padding:4px 10px!important;margin:0!important;width:auto!important;max-width:420px!important;line-height:1.1!important}",
      ".product-details-price[data-mz-adwords-price-test-layout] h2.offers.mgt-price-banner-host,.product-details-price[data-mz-adwords-price-test-layout] .offers.mgt-price-banner-host{display:flex!important;align-items:center!important;justify-content:flex-start!important;gap:10px!important;flex-wrap:nowrap!important}",
      ".product-details-price[data-mz-adwords-price-test-layout] .mgt-price-country-banner{display:inline-flex!important;align-items:center!important;justify-content:center!important;min-height:36px!important;padding:4px 10px!important;margin:0!important;width:auto!important;max-width:420px!important;line-height:1.1!important}",
      "@media(max-width:749px){.product-details-price[data-mz-adwords-price-test-layout] h2.offers.mgt-price-banner-host-clean,.product-details-price[data-mz-adwords-price-test-layout] .offers.mgt-price-banner-host-clean,.product-details-price[data-mz-adwords-price-test-layout] h2.offers.mgt-price-banner-host,.product-details-price[data-mz-adwords-price-test-layout] .offers.mgt-price-banner-host{flex-wrap:wrap!important;align-items:flex-start!important}.product-details-price[data-mz-adwords-price-test-layout] .mgt-price-country-banner-clean,.product-details-price[data-mz-adwords-price-test-layout] .mgt-price-country-banner{width:100%!important;max-width:100%!important;min-height:34px!important}}",
      ".product-details-price[data-mz-adwords-price-test-layout] .price-preview{display:flex!important;flex-direction:column!important;align-items:flex-start!important;gap:2px!important;text-align:left!important}",
      ".product-details-price[data-mz-adwords-price-test-layout] [data-variant-compare-at-price]{order:1!important;display:block!important;font-size:0.55em!important;line-height:1.1!important;color:#666!important;text-decoration:line-through!important;font-weight:400!important}",
      ".product-details-price[data-mz-adwords-price-test-layout] [data-variant-price]{order:2!important;display:block!important;font-size:1em!important;line-height:1.05!important;color:#d74d01!important;font-weight:700!important}",
      ".product-details-price[data-mz-adwords-price-test-layout] [data-savings]{display:none!important}",
      ".product-details-price[data-mz-adwords-price-test-layout] #mz-adwords-price-test-countdown{margin:-2px 0 0 0!important;padding:0!important;border:0!important;background:transparent!important;font-weight:700!important;text-align:right!important}",
      "@media(max-width:749px){.product-details-price[data-mz-adwords-price-test-layout] [data-variant-compare-at-price]{font-size:0.5em!important}}"
    ].join("\n");
    document.head.appendChild(style);
  }
    function forceInlineStyle(el, prop, value){
      if (!el) return;
      try { el.style.setProperty(prop, value, "important"); } catch (e) {}
    }
    function enforcePriceBannerRowLayout(host, priceHeading){
      if (!host) return;
      var heading = priceHeading || host.querySelector("h2.offers, .offers");
      if (!heading) return;

      forceInlineStyle(heading, "display", "flex");
      forceInlineStyle(heading, "flex-wrap", "nowrap");
      forceInlineStyle(heading, "align-items", "center");
      forceInlineStyle(heading, "justify-content", "flex-start");
      forceInlineStyle(heading, "gap", "10px");

      var pricePreview = heading.querySelector(".price-preview");
      if (pricePreview) {
        forceInlineStyle(pricePreview, "width", "auto");
        forceInlineStyle(pricePreview, "max-width", "none");
        forceInlineStyle(pricePreview, "flex", "0 0 auto");
        forceInlineStyle(pricePreview, "display", "flex");
        forceInlineStyle(pricePreview, "flex-direction", "column");
        forceInlineStyle(pricePreview, "align-items", "flex-start");
        forceInlineStyle(pricePreview, "justify-content", "center");
        forceInlineStyle(pricePreview, "text-align", "left");
        forceInlineStyle(pricePreview, "margin", "0");
      }

      var banner = heading.querySelector("#mgt-price-country-banner-clean, .mgt-price-country-banner-clean, #mgt-price-country-banner, .mgt-price-country-banner");
      if (banner) {
        forceInlineStyle(banner, "display", "inline-flex");
        forceInlineStyle(banner, "align-items", "center");
        forceInlineStyle(banner, "justify-content", "center");
        forceInlineStyle(banner, "width", "auto");
        forceInlineStyle(banner, "max-width", "420px");
        forceInlineStyle(banner, "min-height", "36px");
        forceInlineStyle(banner, "padding", "4px 10px");
        forceInlineStyle(banner, "margin", "0");
        forceInlineStyle(banner, "line-height", "1.1");
        forceInlineStyle(banner, "box-sizing", "border-box");
        forceInlineStyle(banner, "align-self", "center");
      }

      if (window.matchMedia && window.matchMedia("(max-width: 749px)").matches) {
        forceInlineStyle(heading, "flex-wrap", "wrap");
        forceInlineStyle(heading, "align-items", "flex-start");
        if (banner) {
          forceInlineStyle(banner, "width", "100%");
          forceInlineStyle(banner, "max-width", "100%");
          forceInlineStyle(banner, "min-height", "34px");
        }
      }
    }

    function applyLayout(){
      var host = document.querySelector(".product-details-price");
      if (!host) return;
      ensureStyles();
      host.setAttribute("data-mz-adwords-price-test-layout", "1");
      var savings = host.querySelector("[data-savings]");
      if (savings) savings.style.display = "none";
      var priceHeading = host.querySelector("h2.offers, .offers");
      var timer = document.getElementById("mz-adwords-price-test-countdown");
      if (host && priceHeading && timer && timer.parentNode === host && timer !== priceHeading.nextSibling) {
        host.insertBefore(timer, priceHeading.nextSibling);
      }
      enforcePriceBannerRowLayout(host, priceHeading);
    }
  function init(){
    var handle = productHandle();
    if (!handle) return;
    fetch("/products/" + encodeURIComponent(handle) + ".js", {credentials:"same-origin"})
      .then(function(r){ return r.ok ? r.json() : null; })
      .then(function(product){
        if (!product || !product.tags || !hasTag(product.tags, "priceoffer")) return;
        applyLayout();
        setTimeout(applyLayout, 100);
        setTimeout(applyLayout, 500);
        setTimeout(applyLayout, 1500);
      })
      .catch(function(){});
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();
